// Shared width convention for the three shells (AppShell, AdminShell,
// SecurityShell): data areas (tables/lists/card-grids) scale up to
// max-w-screen-2xl instead of each page picking its own cap. Prose/form
// columns are the one legitimate exception and may still pass a narrower
// `className` override (e.g. `max-w-2xl`) for the wrapped copy.
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export function PageContainer({
  children,
  className,
}: Readonly<{
  children: ReactNode;
  className?: string;
}>) {
  return <div className={cn('max-w-screen-2xl mx-auto px-6 md:px-8', className)}>{children}</div>;
}
